import { useEffect, useState } from "react";
import { Lock, LifeBuoy, ShieldAlert, ChevronDown } from "lucide-react";

const P = {
  facebook: "M14 8h3V4h-3c-2.8 0-4.5 1.8-4.5 4.6V11H7v4h2.5v9h4v-9H16l.5-4h-3V8.9c0-.6.4-.9 1-.9z",
  whatsapp: "M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.6 14.2c-.2.7-1.4 1.3-2 1.4-.5.1-1.2.1-1.9-.1a17 17 0 0 1-1.8-.7 13.5 13.5 0 0 1-5.2-4.6c-.4-.5-1.1-1.6-1.1-3s.8-2.2 1-2.5c.3-.3.6-.4.8-.4h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .6l-.4.6-.4.5c-.2.2-.3.4-.1.7.2.3.9 1.4 1.9 2.3 1.3 1.1 2.4 1.5 2.7 1.7.3.1.5.1.7-.1l1-1.2c.2-.3.4-.3.7-.2l2 1c.3.1.5.2.6.3.1.2.1.8-.2 1.5z",
  youtube: "M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12a31 31 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8zM9.8 15.1V8.9l5.7 3.1-5.7 3.1z",
  instagram: "M12 7.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zm0 7.6a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4.8-8.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zM21.9 7c-.1-1.6-.4-3-1.6-4.2S17.6 1.2 16 1.1C14.4 1 9.6 1 8 1.1 6.4 1.2 5 1.6 3.8 2.8S2.2 5.4 2.1 7C2 8.6 2 13.4 2.1 15c.1 1.6.4 3 1.6 4.2s2.6 1.5 4.2 1.6c1.6.1 6.4.1 8 0 1.6-.1 3-.4 4.2-1.6s1.5-2.6 1.6-4.2c.1-1.6.1-6.4.2-8zM19.8 18a3 3 0 0 1-1.7 1.7c-1.2.5-4 .4-5.3.4s-4.1.1-5.3-.4A3 3 0 0 1 5.8 18c-.5-1.2-.4-4-.4-5.3s-.1-4.1.4-5.3A3 3 0 0 1 7.5 5.7c1.2-.5 4-.4 5.3-.4s4.1-.1 5.3.4a3 3 0 0 1 1.7 1.7c.5 1.2.4 4 .4 5.3s.1 4.1-.4 5.3z",
  x: "M17.8 2h3.4l-7.4 8.5L22.5 22h-6.8l-5.3-7-6.1 7H.9l7.9-9.1L.5 2h7l4.8 6.4L17.8 2zm-1.2 18h1.9L6.5 3.9H4.5L16.6 20z",
  pinterest: "M12 1a11 11 0 0 0-4 21.2c-.1-.9-.2-2.3 0-3.3l1.4-5.8s-.4-.7-.4-1.7c0-1.6.9-2.8 2.1-2.8 1 0 1.5.7 1.5 1.6 0 1-.6 2.5-1 3.9-.3 1.2.6 2.1 1.7 2.1 2.1 0 3.7-2.2 3.7-5.4 0-2.8-2-4.8-4.9-4.8-3.4 0-5.3 2.5-5.3 5.1 0 1 .4 2.1.9 2.7.1.1.1.2.1.3l-.3 1.4c-.1.2-.2.3-.4.2-1.5-.7-2.4-2.9-2.4-4.6 0-3.8 2.7-7.2 7.9-7.2 4.1 0 7.3 2.9 7.3 6.9 0 4.1-2.6 7.4-6.2 7.4-1.2 0-2.3-.6-2.7-1.4l-.7 2.8c-.3 1-1 2.3-1.5 3.1A11 11 0 1 0 12 1z",
};

export const SocialRow = ({ links, label }) => {
  const items = ["facebook", "whatsapp", "youtube", "instagram", "x", "pinterest"].filter((k) => links[k]);
  if (items.length < 2) return null;
  return (
    <div className="flex flex-col items-center gap-4" data-testid="footer-social-row">
      <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">{label}</p>
      <div className="flex flex-wrap justify-center gap-3">
        {items.map((k) => (
          <a key={k} href={links[k]} target="_blank" rel="noreferrer" aria-label={k} data-testid={`footer-social-${k}`}
            className="fx-icon grid h-11 w-11 place-items-center rounded-full bg-gradient-to-br from-[#F3D77A] via-[#D4AF37] to-[#9A7B2C] text-black transition-transform hover:-translate-y-1">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden><path d={P[k]} /></svg>
          </a>
        ))}
      </div>
    </div>
  );
};

export const TrustStrip = ({ t }) => (
  <div className="grid grid-cols-2 gap-3 sm:flex sm:flex-wrap sm:items-center sm:justify-center sm:gap-4" data-testid="footer-trust-strip">
    <span className="flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-3 py-2 text-xs text-zinc-300" data-testid="trust-18">
      <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full border-2 border-[#D4AF37] font-serif text-[10px] font-bold text-[#D4AF37]">18+</span>{t.adults || "Adults only"}
    </span>
    <span className="flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-3 py-2 text-xs text-zinc-300" data-testid="trust-ssl"><Lock size={15} className="shrink-0 text-[#D4AF37]" />{t.ssl}</span>
    <a href="/p/responsible-gambling" className="flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-3 py-2 text-xs text-zinc-300 hover:text-white" data-testid="trust-help"><LifeBuoy size={15} className="shrink-0 text-[#D4AF37]" />{t.help}</a>
    <a href="https://www.begambleaware.org" target="_blank" rel="noreferrer nofollow" className="flex items-center gap-2 rounded-full border border-[#D4AF37]/40 px-3 py-2 text-xs font-semibold text-zinc-200 hover:text-white" data-testid="trust-begambleaware">
      <ShieldAlert size={15} className="shrink-0 text-[#D4AF37]" />{t.gamble}
    </a>
  </div>
);

export const Disclaimer = ({ t }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-[#D4AF37]/20 bg-white/[0.02] p-5 sm:p-6" data-testid="footer-disclaimer">
      <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">{t.disclaimer_title}</h3>
      <p className="mt-3 text-xs leading-relaxed text-zinc-400">{t.disclaimer}</p>
      <button onClick={() => setOpen(!open)} data-testid="disclaimer-toggle" className="mt-3 flex items-center gap-1 text-xs uppercase tracking-wider text-[#D4AF37] sm:hidden">
        {open ? t.hide : t.show} <ChevronDown size={13} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <p className={`mt-3 text-xs leading-relaxed text-zinc-500 ${open ? "" : "hidden sm:block"}`} data-testid="disclaimer-territories">{(t.territories || []).join(", ")}.</p>
    </div>
  );
};

export const useIsMobile = () => {
  const q = "(max-width: 639px)";
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return m;
};

export const useScrolledPast = (px) => {
  const [past, setPast] = useState(false);
  useEffect(() => {
    const on = () => setPast(window.scrollY > px);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, [px]);
  return past;
};

export const useFooterVisible = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = document.getElementById("site-footer");
    if (!el) return;
    const io = new IntersectionObserver(([e]) => setVisible(e.isIntersecting), { rootMargin: "0px 0px -80px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return visible;
};
